module.exports = __webpack_public_path__ + "static/img/noData.51c6dbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/docCenter/noData.png
// module id = y5ZA
// module chunks = 1